import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-offres-de-formation',
  templateUrl: './offres-de-formation.component.html',
  styleUrls: ['./offres-de-formation.component.scss']
})
export class OffresDeFormationComponent implements OnInit {
  submenu: any;
  submenuList: any = ['offre-de-formation', 'formations-intraentreprises', 'inter-entreprise', 'individuelle'];
  constructor(private router: Router, private route: ActivatedRoute) {
    this.submenu = this.route.snapshot.paramMap.get('submenu');
    if (!this.submenuList.includes(this.submenu)) {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit(): void {
  }

}
